<template>
  <div>
    <v-btn @click="openCreateDialog" color="primary">Nowy</v-btn>
    <data-table :items="locales" :headers="headers">
      <template #item.actions="{ item }">
        <v-menu bottom :close-on-content-click="false">
          <template v-slot:activator="{ on, attrs }">
            <v-btn color="primary" v-bind="attrs" v-on="on" class="mr-2"
              >Tłumaczenia</v-btn
            >
          </template>
          <div class="py-1 px-3 white">
            <v-autocomplete
              label="Wybierz wdrożenie"
              v-model="selectedCompany"
              :items="companies"
              item-text="name"
              item-value="id"
            ></v-autocomplete>
            <v-btn
              :disabled="!selectedCompany"
              class="mb-2"
              color="primary"
              @click="goToTranslations"
              >Przejdź</v-btn
            >
          </div>
        </v-menu>
        <v-btn color="error" @click="deleteLocale(item)">Usuń</v-btn>
      </template>
    </data-table>
    <v-dialog v-model="createDialog" persistent width="800">
      <v-card v-if="createVm">
        <v-card-title>Nowy język</v-card-title>
        <v-card-text>
          <v-autocomplete
            label="Język"
            v-model="createVm.locale"
            :item-text="itemText"
            :item-value="itemValue"
            :items="availableTags"
          ></v-autocomplete>
        </v-card-text>
        <v-card-actions>
          <v-btn color="primary" @click="create">Zapisz</v-btn>
          <v-btn color="error" @click="closeCreateDialog">Anuluj</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import tags from "locale-codes";
export default {
  data() {
    return {
      locales: [],
      createDialog: false,
      createVm: {},
      headers: [
        { text: "Id", value: "id" },
        { text: "Nazwa", value: "name" },
        { text: "Tag", value: "tag" },
        { text: "Opcje", value: "actions" },
      ],
      companies: [],
      selectedCompany: null,
    };
  },
  computed: {
    availableTags() {
      return tags.all;
    },
  },
  methods: {
    async getCompanies() {
      const { data } = await this.$http.get("Company/GetSimpleCompanies");
      this.companies = data;
    },
    async getLocales() {
      const { data } = await this.$http.get("Locale/GetLocales");
      this.locales = data;
    },
    itemText(item) {
      return `${item.tag} - ${item.name} - ${item.local}`;
    },
    itemValue(item) {
      return item;
    },
    async create() {
      await this.$http.post("Locale/CreateLocale", {
        tag: this.createVm.locale.tag,
        name: this.createVm.locale.name,
      });

      this.createVm = {};
      this.createDialog = false;
      await this.getLocales();
    },
    async deleteLocale(item) {
      if (confirm("Czy na pewno chcesz usunać język wraz z tłumaczeniami?")) {
        await this.$http.delete("Locale/DeleteLocale?id=" + item.id);
        await this.getLocales();
      }
    },
    closeCreateDialog() {
      this.createVm = {};
      this.createDialog = false;
    },
    openCreateDialog() {
      this.createVm = {};
      this.createDialog = true;
    },
    goToTranslations() {
      this.$router.push({
        name: "Translations",
        params: { companyId: this.selectedCompany },
      });
    },
  },
  async mounted() {
    await this.getLocales();
    await this.getCompanies();
  },
};
</script>